import { FormattedMessage } from "react-intl";
import MetaCard from "../MetaCard/MetaCard";
import TextDirAligner from "../../../Shared/TextDirAligner/TextDirAligner";

type CommentsProps = {
  comments?: string;
  compare?: boolean;
};

const Comments = ({ comments, compare }: CommentsProps) => (
  <MetaCard compare={compare}>
    <div className="font-md">
      <p className="mb-0 prim-color-dark font-weight-bold">
        <FormattedMessage id="ECG_DETAILS.COMMENTS" defaultMessage="Comments" />
      </p>
      {comments && (
        <TextDirAligner className="mt-2 mb-0">{comments}</TextDirAligner>
      )}
    </div>
  </MetaCard>
);

export default Comments;
